import type * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-10 w-full min-w-0 rounded-full border bg-transparent px-4 py-1 text-base shadow-xs transition-[color,box-shadow,opacity,transform] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-base [&_svg:not([class*='size-'])]:size-5",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] [&[data-slot='input']]:focus-visible:ring-0 [&[data-slot='input']]:focus-visible:border-gray-400",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        "placeholder:transition-[opacity,transform] placeholder:duration-300 placeholder:ease-out",
        "focus:placeholder:opacity-0 focus:placeholder:-translate-x-2",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
